import { ajaxSend } from '../../../api/api';

import { getLocalSettings, updateSettings } from './personal';

const basePath = '/v1/templating/templates';
const basePathV2 = '/v2/templating/templates';

const SORT_LOCALSTORAGE_NAME = 'templatesSortBy';

export function getAll(payload: { type: string | null }) {
  const type = payload;
  let queryType = '';
  if (type && typeof type === 'string') {
    if (type === 'auto_reply') {
      queryType = '?template_type=auto_reply';
    } else if (type === 'quick_response') {
      queryType = '?template_type=quick_response';
    }
  }
  const request = {
    path: `${basePath}${queryType}`,
  };

  return ajaxSend(request);
}

export function readTemplateById(payload: { templateId: string }) {
  const { templateId } = payload;

  const request = {
    path: `${basePathV2}/${templateId}`,
  };
  return ajaxSend(request);
}

export function addById(payload: any) {
  return ajaxSend({
    path: `${basePathV2}`,
    method: 'POST',
    data: payload,
  });
}

export function updateById(payload: any) {
  const { updates, deletes, name } = payload;
  const patch = {
    updates: updates,
    deletes: deletes,
  };
  return ajaxSend({
    path: `${basePathV2}/${encodeURIComponent(name)}`,
    method: 'PATCH',
    data: patch,
  });
}

export function deleteTemplateById(payload: any) {
  const { template } = payload;
  return ajaxSend({
    path: `${basePathV2}/${encodeURIComponent(template.id)}`,
    method: 'DELETE',
    data: payload,
  });
}

export function setSortTemplate(payload: { sortType: string } | null = null) {
  if (payload === undefined || payload === null) {
    console.error('sortType - No valid payload given.');
    return Promise.reject(null);
  }

  const { sortType } = payload;

  if (typeof sortType !== 'string') {
    console.error('sortType - No valid payload given.');
    return Promise.reject(null);
  }

  try {
    updateSettings({ key: SORT_LOCALSTORAGE_NAME, value: sortType });
    return Promise.resolve(sortType);
  } catch (e) {
    return Promise.reject(e);
  }
}

export function getSortTemplate() {
  try {
    const localSettings = getLocalSettings();
    if (localSettings) {
      return Promise.resolve(localSettings.templatesSortBy);
    }
    return Promise.resolve(null);
  } catch (e) {
    return Promise.reject(e);
  }
}

export function render(payload: any) {
  return ajaxSend({
    path: `/v1/templating/renderings`,
    method: 'POST',
    data: payload,
  });
}
